import { Animation } from '../components/animation'

export const scrollTo = () => {
    let animation = new Animation;

    const countFixedBlockHeight = () => {
        let fixedBlockHeight;

        if (window.innerWidth > 999) {
            fixedBlockHeight = 101;
        } else if (window.innerWidth < 999 && window.innerWidth > 779) {
            fixedBlockHeight = 94;
        } else {
            fixedBlockHeight = 60;
        }

        return fixedBlockHeight
    }

    let urlAnchor = window.location.hash.replace('#','');
    if (urlAnchor) {
        setTimeout( function() {
            animation.scroll(document.querySelector(`#${urlAnchor}`), countFixedBlockHeight(), 0);
        }, 1000)
    }

    let navItem = document.querySelectorAll('[data-target]');

    let burgerBtn = document.querySelector('[am-block="burger"]'),
        burgerMenu = document.querySelector('[am-menu="burger"]');

    navItem.forEach( (item) => {
        item.addEventListener('click', () => {
            let name = item.dataset.target,
                elem = document.querySelector(`[am-section="${name}"]`);

            burgerBtn.classList.remove('is-active');
            burgerMenu.classList.remove('is-active');

            if (elem) {
                animation.scroll(elem, countFixedBlockHeight())
            } else {
                window.location.href = `/#${name}`
            }

        });
    });
}
